import React, { useState } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import jwt_decode from "jwt-decode";
import morrisonsLogin from "assets/images/login_new.jpg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { loginSuccess, setUsersType } from "redux/actions/userActions";
import { showNotificationDialog } from "redux/actions/notificationActions";
import { postTokenSession, postToken } from "services/loginService";
import { SOMS_API_KEY, AUTH } from "services/CONSTANTS";
import { ID_TOKEN, PAGE } from "components/common/CONSTANTS";
import moment from "moment";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import { Getlocations } from "redux/actions/locationActions";
import { showErrorMessageByCode } from "services/commonServices";
import { decryption, encryptRequest } from "components/common/EncryptDecrypt";
import { getResonCodes } from "redux/actions/reasonCodesActions";
import { getUserAccessiblePages } from "components/common/Utility";

export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { loginResponse } = useSelector((state) => state.user);

  const [showSpinner, setShowSpinner] = useState(false);

  const CallV2 = (token) => {
    setShowSpinner(true);
    let encoded = window.btoa(AUTH);

    const params = new URLSearchParams();
    params.append("grant_type", "password");
    params.append("id_token", token);

    const request = {
      config: {
        headers: {
          Authorization: "Basic " + window.atob(encoded),
          "Content-Type": "application/x-www-form-urlencoded",
          "Content-Security-Policy": "strict-dynamic",
          "X-Content-Type-Options": "nosniff",
        },
      },
      params,
    };

    postToken(request)
      .then((response) => {
        getPrivilege(response, token);
      })
      .catch((error) => {
        setShowSpinner(false);
        dispatch(
          showNotificationDialog("Morrisons", "Unauthorized user!", "Ok")
        );
      });
  };

  const getPrivilege = async (response, token) => {
    const credentials = jwt_decode(token);
    const finalReq = {
      tokenType: ID_TOKEN,
      accessToken: response.access_token,
      expiresIn: response.expires_in,
      refreshToken: response.refresh_token,
      scope: "",
      userType: response.userType,
      empId: response.empId,
      primaryEmailAddress: response.primaryEmailAddress,
      roleCode: response.roleCode,
      roles: "",
    };

    const encryptFinalReq = await encryptRequest(finalReq);

    const request = {
      apikey: SOMS_API_KEY,
      params: {
        token: encryptFinalReq,
      },
      userId: response.primaryEmailAddress,
    };

    postTokenSession(request)
      .then(async (response) => {
        const data = response.responseData;
        const decryptedData = await decryption(data);
        let responseData = JSON.parse(decryptedData);
        if (responseData.userId === credentials.email) {
          localStorage.setItem("expires_in", responseData.expiresIn);
          sessionStorage.clear();
          sessionStorage.setItem("token", token);
          sessionStorage.setItem(
            "lastTimeStamp",
            localStorage.getItem("lastTimeStamp")
          );
          sessionStorage.setItem("refreshToken", responseData.refreshToken);
          sessionStorage.setItem("accessToken", responseData.accessToken);
          let timeStamp = moment();
          sessionStorage.setItem("loggedInTimestamp", timeStamp);
          responseData.accessiblePages = getUserAccessiblePages(
            responseData.userDetailResponse
          );

          dispatch(loginSuccess(credentials));
          dispatch(setUsersType(responseData));
          dispatch(Getlocations());
          dispatch(getResonCodes({ status: "Active" }));

          navigate(PAGE.HOME.url);
        } else {
          setShowSpinner(false);
          dispatch(
            showNotificationDialog("Morrisons", "Unauthorized user!", "Ok")
          );
        }
      })
      .catch((error) => {
        console.log("error", error);
        const { errTitle, errContent } = showErrorMessageByCode(error);
        setShowSpinner(false);
        dispatch(
          showNotificationDialog(
            errTitle,
            error.response === undefined ? errContent : error.response.data,
            "Ok"
          )
        );
      });
  };

  return (
    <>
      {loginResponse ? (
        <Navigate to="/home" />
      ) : (
        <>
          {showSpinner && (
            <Backdrop
              sx={{
                color: "#fff",
                flexDirection: "column",
                zIndex: (theme) => theme.zIndex.drawer + 1,
              }}
              open={true}
            >
              <CircularProgress color="inherit" />

              <Typography variant="h6" sx={{ marginTop: 2 }}>
                Authorizing User. Please Wait...
              </Typography>
            </Backdrop>
          )}
          <Grid container sx={{ height: "80vh", py: 8, px: 15 }}>
            <Grid
              item
              xs={false}
              sm={4}
              md={7}
              sx={{
                backgroundImage: `url(${morrisonsLogin})`,
                backgroundRepeat: "no-repeat",
                backgroundColor: (t) =>
                  t.palette.mode === "light"
                    ? t.palette.grey[50]
                    : t.palette.grey[900],
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
            />
            <Grid
              item
              xs={12}
              sm={8}
              md={5}
              component={Paper}
              elevation={0}
              square
              backgroundColor="#f5f5f5"
              display="flex"
              flexDirection="row"
              alignContent="center"
              alignItems="center"
            >
              <Box
                sx={{
                  my: 8,
                  mx: 4,
                  display: "flex",
                  flexDirection: "column",
                  alignContent: "center",
                  backgroundColor: "#f5f5f5",
                }}
              >
                <Typography
                  component="h1"
                  variant="h5"
                  fontWeight="bold"
                  color="#3b3633"
                  mb={1}
                >
                  Sign in to your account
                </Typography>

                <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID}>
                  <GoogleLogin
                    onSuccess={(credentialResponse) => {
                      CallV2(credentialResponse.credential);
                    }}
                    onError={() => {
                      console.error("Login Failed");
                    }}
                  />
                </GoogleOAuthProvider>
              </Box>
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
}
